module.exports = __webpack_public_path__ + "static/img/stay-option-icon-couple.a5d533ce.svg";